var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "36.684px",
    viewBox: "0 0 55 36.684",
    enableBackground: "new 0 0 55 36.684",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M42.369,36.108h-6.263V25.517h-0.331v10.592H19.224V25.517h-0.33v10.592h-6.263V21.159l4.927-4.926h19.885 l4.927,4.926V36.108z M37.606,34.608h3.263V21.78l-4.048-4.047H18.179l-4.048,4.047v12.828h3.263V24.017h3.33v10.592h13.552 V24.017h3.331V34.608z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M27.5,15.627c-4.15,0-7.526-3.376-7.526-7.526c0-4.149,3.376-7.525,7.526-7.525 c4.149,0,7.525,3.376,7.525,7.525C35.025,12.251,31.649,15.627,27.5,15.627z M27.5,2.075c-3.323,0-6.026,2.703-6.026,6.025 c0,3.323,2.703,6.026,6.026,6.026c3.322,0,6.025-2.703,6.025-6.026C33.525,4.778,30.822,2.075,27.5,2.075z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.118570bdca79f6e9b9b4a8ba602fad9a.svg";
export { ForwardRef as ReactComponent };